import React from "react";
import {
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Typography,
	Divider,
	Box,
	Popover,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import DescriptionIcon from "@mui/icons-material/Description";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import { useSnackbar } from "notistack";

interface ChatActionMenuProps {
	anchorEl: null | HTMLElement;
	onClose: () => void;
	onShareAction: (type: "customer" | "contract" | "invoice") => void;
}

export const ChatActionMenu: React.FC<ChatActionMenuProps> = ({
	anchorEl,
	onClose,
	onShareAction,
}) => {
	const { enqueueSnackbar } = useSnackbar();

	const handleQuickAction = () => {
		enqueueSnackbar("quick actions хийгдэж байна", { variant: "info" });
		onClose();
	};

	const handleShare = (type: "customer" | "contract" | "invoice") => {
		onShareAction(type);
		onClose();
	};

	return (
		<Popover
			open={Boolean(anchorEl)}
			anchorEl={anchorEl}
			onClose={onClose}
			disableScrollLock={true}
			anchorOrigin={{
				vertical: "top",
				horizontal: "left",
			}}
			transformOrigin={{
				vertical: "bottom",
				horizontal: "left",
			}}
			PaperProps={{
				sx: { borderRadius: 3, mb: 1, minWidth: 160 },
			}}
		>
			<List dense sx={{ p: 1, minWidth: 240 }}>
				<Typography
					variant="caption"
					sx={{
						px: 2,
						py: 1,
						color: "text.secondary",
						fontWeight: "bold",
						display: "block",
					}}
				>
					SHARE RECORD
				</Typography>
				<ListItem disablePadding sx={{ mb: 0.5 }}>
					<ListItemButton
						onClick={() => handleShare("customer")}
						sx={{ borderRadius: 2 }}
					>
						<ListItemIcon sx={{ minWidth: 44 }}>
							<Box
								sx={{
									width: 32,
									height: 32,
									borderRadius: "50%",
									backgroundColor: "rgba(25, 118, 210, 0.1)",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									color: "#1976d2",
								}}
							>
								<PersonIcon fontSize="small" />
							</Box>
						</ListItemIcon>
						<ListItemText
							primary="Харилцагч"
							primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}
						/>
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding sx={{ mb: 0.5 }}>
					<ListItemButton
						onClick={() => handleShare("contract")}
						sx={{ borderRadius: 2 }}
					>
						<ListItemIcon sx={{ minWidth: 44 }}>
							<Box
								sx={{
									width: 32,
									height: 32,
									borderRadius: "50%",
									backgroundColor: "rgba(156, 39, 176, 0.1)",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									color: "#9c27b0",
								}}
							>
								<DescriptionIcon fontSize="small" />
							</Box>
						</ListItemIcon>
						<ListItemText
							primary="Үйлчилгээний Гэрээ"
							primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}
						/>
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding sx={{ mb: 0.5 }}>
					<ListItemButton
						onClick={() => handleShare("invoice")}
						sx={{ borderRadius: 2 }}
					>
						<ListItemIcon sx={{ minWidth: 44 }}>
							<Box
								sx={{
									width: 32,
									height: 32,
									borderRadius: "50%",
									backgroundColor: "rgba(237, 108, 2, 0.1)",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									color: "#ed6c02",
								}}
							>
								<ReceiptIcon fontSize="small" />
							</Box>
						</ListItemIcon>
						<ListItemText
							primary="Нэхэмжлэх"
							primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}
						/>
					</ListItemButton>
				</ListItem>

				<Divider sx={{ my: 1 }} />

				<Typography
					variant="caption"
					sx={{
						px: 2,
						py: 1,
						color: "text.secondary",
						fontWeight: "bold",
						display: "block",
					}}
				>
					QUICK ACTIONS
				</Typography>
				<ListItem disablePadding sx={{ mb: 0.5 }}>
					<ListItemButton
						onClick={handleQuickAction}
						sx={{ borderRadius: 2 }}
					>
						<ListItemIcon sx={{ minWidth: 44 }}>
							<Box
								sx={{
									width: 32,
									height: 32,
									borderRadius: "50%",
									backgroundColor: "rgba(211, 47, 47, 0.1)",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									color: "#d32f2f",
								}}
							>
								<ConfirmationNumberIcon fontSize="small" />
							</Box>
						</ListItemIcon>
						<ListItemText
							primary="Тикет нээх"
							primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}
						/>
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding sx={{ mb: 0.5 }}>
					<ListItemButton
						onClick={handleQuickAction}
						sx={{ borderRadius: 2 }}
					>
						<ListItemIcon sx={{ minWidth: 44 }}>
							<Box
								sx={{
									width: 32,
									height: 32,
									borderRadius: "50%",
									backgroundColor: "rgba(46, 125, 50, 0.1)",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									color: "#2e7d32",
								}}
							>
								<CreditCardIcon fontSize="small" />
							</Box>
						</ListItemIcon>
						<ListItemText
							primary="Төлбөр баталгаажуулах"
							primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}
						/>
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding>
					<ListItemButton
						onClick={handleQuickAction}
						sx={{ borderRadius: 2 }}
					>
						<ListItemIcon sx={{ minWidth: 44 }}>
							<Box
								sx={{
									width: 32,
									height: 32,
									borderRadius: "50%",
									backgroundColor: "rgba(2, 136, 209, 0.1)",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									color: "#0288d1",
								}}
							>
								<InsertChartOutlinedIcon fontSize="small" />
							</Box>
						</ListItemIcon>
						<ListItemText
							primary="Системийн тайлан хавсаргах"
							primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}
						/>
					</ListItemButton>
				</ListItem>
			</List>
		</Popover>
	);
};
